import { render, staticRenderFns } from "./PreSelfAssessment.vue?vue&type=template&id=6f441ecc&scoped=true&"
import script from "./PreSelfAssessment.vue?vue&type=script&lang=js&"
export * from "./PreSelfAssessment.vue?vue&type=script&lang=js&"
import style0 from "./PreSelfAssessment.vue?vue&type=style&index=0&id=6f441ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f441ecc",
  null
  
)

export default component.exports